module.exports = __webpack_public_path__ + "img/MobileDisabledFeedbackOkay.c97f7e60.png";